import blp from './blp/handler';
import dds from './dds/handler';
import m3 from './m3/handler';
import mdx from './mdx/handler';
import tga from './tga/handler';
import War3MapViewer from './w3x/viewer';

export default {
  blp,
  dds,
  m3,
  mdx,
  tga,
  War3MapViewer,
};
